<template>
    <div class="signDialog">
        <el-row class="receiveRight">
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">运输单号：</span>
                    <span class="value">{{totalData.waybillNo}}</span>
                </div>
            </el-col>
            <el-col :span="16">
                <div class="colItem">
                    <span class="label">客户订单号：</span>
                    <span class="value">{{totalData.customerOrderNo}}</span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">网点名称：</span>
                    <span class="value">{{totalData.networkName}}</span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">网点联系方式：</span>
                    <span class="value">{{
                            totalData.networkContact + ' / ' +
                            totalData.networkMoblie + ' / ' +
                            totalData.networkTel
                        }}</span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">网点签收时间：</span>
                    <span class="value">{{totalData.networkSignTime}}</span>
                </div>
            </el-col>
            <el-col :span="24">
                <div class="colItem">
                    <span class="label">网点详细地址：</span>
                    <span class="value">{{totalData.networkAddr}}</span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">用户名称：</span>
                    <span class="value">{{totalData.receiverName}}</span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">用户联系方式：</span>
                    <span class="value">{{
                            totalData.receiverName + ' / ' +
                            totalData.receiverMobile + ' / ' +
                            totalData.receiverTel
                        }}</span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">用户签收时间：</span>
                    <span class="value">{{totalData.receiverSignTime}}</span>
                </div>
            </el-col>
            <el-col :span="24">
                <div class="colItem">
                    <span class="label">用户详细地址：</span>
                    <span class="value">{{totalData.receiverAddr}}</span>
                </div>
            </el-col>
        </el-row>

        <el-table :data="totalData.itemDetails || []" border tooltip-effect="dark" height="260">
            <el-table-column v-for="(item, index) in columns" :key='index'
                :show-overflow-tooltip='true' :prop="item.prop" :label="item.label" align='center'></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        totalData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            columns: [
                { prop: 'itemCode', label: '商品编码' },
                { prop: 'itemName', label: '商品名称' },
                { prop: 'planQty', label: '商品数量' },
                { prop: 'realReceive', label: '网点签收正品' },
                { prop: 'rejectQty', label: '网点签收拒收' },
                { prop: 'receiverRealReceiveCount', label: '用户签收正品' },
                { prop: 'receiverRejectQty', label: '用户签收拒收' }
            ]
        };
    }
};
</script>

<style lang="less">
@import '../signInDialog.less';
</style>